import css from './loadScreen.module.css'
import firstRocket from '../../../asserts/rockets/FirstRocket.png'
import secondRocket from '../../../asserts/rockets/SecondRocket.png'
import thirdRocket from '../../../asserts/rockets/ThirdRocket.png'

const LoadScreen = () => {
  return (
    <div className={css.wrapper}>
      <div className={css.rocketsWrapper}>
        <div data-index="1" className={css.rocket} style={{ backgroundImage: `url(${firstRocket})` }} />
        <div data-index="2" className={css.rocket} style={{ backgroundImage: `url(${secondRocket})` }} />
        <div data-index="3" className={css.rocket} style={{ backgroundImage: `url(${thirdRocket})` }} />
        <span className={css.inscription}>Загрузка...</span>
      </div>
    </div>
  )
}

export default LoadScreen
